import { pickSessionPriorityViewWithIdSchema } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const getPickSessionPriorityFilters = {
  name: "getPickSessionPriorityFilters" as const,
  input: z.object({}),
  output: z.object({ filters: z.array(pickSessionPriorityViewWithIdSchema) }),
};
